// get enviroment from .env file
export const enviroment = process.env.NODE_ENV;

export const baseurl =
	enviroment === "development"
		? "http://66.175.223.251:3999"
		: "http://66.175.223.251:3999";

export const warningHeader = enviroment === "development" ? "Desarrollo" : "";